import type { Interceptor } from '@connectrpc/connect'

/* Sends the Zitadel-issued JWT access token as a bearer header on every RPC.
   The session store registers its token getter at bootstrap; the indirection
   avoids importing pinia stores before the app exists. The webservice
   validates this JWT (discovery + JWKS) as a resource server. */
let tokenGetter: () => string | null = () => null
let apiOrigin: string | null = null

export function registerTokenGetter(getter: () => string | null): void {
  tokenGetter = getter
}

/* The origin the API transport targets. When set, the bearer token is only
   attached to requests to that origin - so if a second transport is ever
   added, the Zitadel-issued token cannot leak to a foreign endpoint. */
export function registerApiOrigin(origin: string): void {
  apiOrigin = origin
}

export const authInterceptor: Interceptor = (next) => (req) => {
  const token = tokenGetter()
  if (token && (!apiOrigin || new URL(req.url).origin === apiOrigin)) {
    req.header.set('Authorization', `Bearer ${token}`)
  }
  return next(req)
}
